import React from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import { COLORS, FONT } from "../../constants";
import useSystemHook from "../../hooks/SystemHook";

const HeroBanner = ({ bannerUrl, onNewTrade, onExistingTrade }) => {
  const { isMobile } = useSystemHook();

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        minHeight: isMobile ? 320 : 500,
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      <Box
        component="img"
        src={bannerUrl}
        alt="Argus Trade"
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: "center",
          transform: "scaleX(-1)",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(to right, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.55) 40%, rgba(0,0,0,0) 70%)",
        }}
      />
      <Container sx={{ position: "relative", zIndex: 1, py: isMobile ? 6 : 8 }}>
        <Box sx={{ maxWidth: 560 }}>
          <Typography
            variant="h3"
            sx={{
              color: COLORS.white,
              fontWeight: 700,
              mb: 4,
              lineHeight: 1.2,
              fontSize: isMobile ? FONT.size["2xl"] : FONT.size.h1,
            }}
          >
            Open a Trade Account with South Africa's Trusted Automotive Parts
            Supplier
          </Typography>
          <Box sx={{ display: "flex", flexDirection: isMobile ? "column" : "row", gap: 2 }}>
            <Button
              variant="contained"
              onClick={onNewTrade}
              sx={{
                backgroundColor: COLORS.themeYellow,
                color: COLORS.themeBlack,
                fontWeight: 400,
                px: 4,
                py: 1.5,
                borderRadius: "2px",
                textTransform: "none",
                fontSize: isMobile ? FONT.size.sm : FONT.size.md,
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: COLORS.themeYellow,
                  boxShadow: "none",
                },
              }}
            >
              New Trade Account
            </Button>
            <Button
              variant="outlined"
              onClick={onExistingTrade}
              sx={{
                borderColor: COLORS.themeYellow,
                borderWidth: 2,
                color: COLORS.themeYellow,
                fontWeight: 400,
                px: 4,
                py: 1.5,
                borderRadius: "2px",
                textTransform: "none",
                fontSize: isMobile ? FONT.size.sm : FONT.size.md,
                "&:hover": {
                  borderColor: COLORS.themeYellow,
                  borderWidth: 2,
                  backgroundColor: "rgba(255,241,0,0.08)",
                },
              }}
            >
              Existing Trade Account
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default HeroBanner;
